import React from 'react';
import { BlockIcon as Icon } from '@tribeplatform/react-ui-kit/Icon';
import { OutlineIcon } from './OutlineIcon.js';
import { SolidIcon } from './SolidIcon.js';
import { SupportedIconNames } from './types.js';
export const IconBlock = ({ name = SupportedIconNames.RefreshIcon, size = 'md', color = 'default', iconType = 'outline', }) => {
    return (React.createElement(Icon, { color: color, size: size }, iconType === 'solid' ? (React.createElement(SolidIcon, { name: name })) : (React.createElement(OutlineIcon, { name: name }))));
};
//# sourceMappingURL=Block.js.map